import { useTranslation } from "react-i18next";
import { useDecision } from "@optimizely/react-sdk";
import { FormAutocomplete, RowInfo } from "../../common";
import TextTransformationModal from "../modals/TextTransformationModal";

const Text = ({ useQuery }) => {
    const { t } = useTranslation();
    const [decisionAi] = useDecision('ai');

    return (
        <>
            <p dangerouslySetInnerHTML={{ __html: t('Require the player to type words.') }} />
            {
                decisionAi?.enabled
                    ? (
                        <>
                            <RowInfo help={<TextTransformationModal />}>
                                <FormAutocomplete
                                    label={t("Transformations")}
                                    name="task_subtype"
                                    useQuery={useQuery}
                                    options={[
                                        { id: "0", name: t('None') },
                                        { id: "1", name: t('Generate image from submitted text using AI robot artist') },
                                    ]}
                                    size="small"
                                />
                            </RowInfo>
                        </>
                    )
                    : null
            }
        </>
    )
};

export default Text;
